import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";

export default function CookiesPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Back Link */}
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>

        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#DFFF00]/10 flex items-center justify-center">
            <Cookie className="h-6 w-6 text-[#DFFF00]" />
          </div>
          <div>
            <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-3xl font-bold text-white uppercase tracking-tight">
              Cookie-politik
            </h1>
            <p className="text-sm text-zinc-500">Sidst opdateret: 1. marts 2025</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert prose-zinc max-w-none">
          <div className="bg-[#18181b] border border-white/5 rounded-xl p-6 sm:p-8 space-y-8">
            
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Hvad er Cookies?</h2>
              <p className="text-zinc-400 leading-relaxed">
                Cookies er små tekstfiler, der gemmes på din enhed (computer, tablet eller mobiltelefon), når du besøger vores hjemmeside. 
                Cookies hjælper os med at levere en bedre brugeroplevelse og forstå, hvordan vores tjeneste bruges.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">Hvilke Cookies Bruger Vi?</h2>
              
              <div className="space-y-6">
                <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-green-500">
                  <h3 className="text-lg font-semibold text-white mb-2">Nødvendige Cookies</h3>
                  <p className="text-zinc-400 text-sm mb-3">
                    Disse cookies er essentielle for at websitet fungerer korrekt. De kan ikke deaktiveres.
                  </p>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-zinc-500">
                        <th className="pb-2">Navn</th>
                        <th className="pb-2">Formål</th>
                        <th className="pb-2">Varighed</th>
                      </tr>
                    </thead>
                    <tbody className="text-zinc-400">
                      <tr>
                        <td className="py-1 font-mono text-xs">auth_token</td>
                        <td className="py-1">Holder dig logget ind</td>
                        <td className="py-1">Session</td>
                      </tr>
                      <tr>
                        <td className="py-1 font-mono text-xs">user_session</td>
                        <td className="py-1">Session-håndtering</td>
                        <td className="py-1">7 dage</td>
                      </tr>
                      <tr>
                        <td className="py-1 font-mono text-xs">cookie_consent</td>
                        <td className="py-1">Gemmer dit cookie-valg</td>
                        <td className="py-1">1 år</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-blue-500">
                  <h3 className="text-lg font-semibold text-white mb-2">Funktionelle Cookies</h3>
                  <p className="text-zinc-400 text-sm mb-3">
                    Disse cookies forbedrer funktionaliteten ved at huske dine præferencer.
                  </p>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-zinc-500">
                        <th className="pb-2">Navn</th>
                        <th className="pb-2">Formål</th>
                        <th className="pb-2">Varighed</th>
                      </tr>
                    </thead>
                    <tbody className="text-zinc-400">
                      <tr>
                        <td className="py-1 font-mono text-xs">theme_pref</td>
                        <td className="py-1">Gemmer tema-præference</td>
                        <td className="py-1">1 år</td>
                      </tr>
                      <tr>
                        <td className="py-1 font-mono text-xs">language</td>
                        <td className="py-1">Gemmer sprogvalg</td>
                        <td className="py-1">1 år</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-purple-500">
                  <h3 className="text-lg font-semibold text-white mb-2">Analytiske Cookies</h3>
                  <p className="text-zinc-400 text-sm mb-3">
                    Disse cookies hjælper os med at forstå, hvordan besøgende bruger vores hjemmeside.
                  </p>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-zinc-500">
                        <th className="pb-2">Navn</th>
                        <th className="pb-2">Formål</th>
                        <th className="pb-2">Varighed</th>
                      </tr>
                    </thead>
                    <tbody className="text-zinc-400">
                      <tr>
                        <td className="py-1 font-mono text-xs">_ga</td>
                        <td className="py-1">Google Analytics - brugeridentifikation</td>
                        <td className="py-1">2 år</td>
                      </tr>
                      <tr>
                        <td className="py-1 font-mono text-xs">_gid</td>
                        <td className="py-1">Google Analytics - session</td>
                        <td className="py-1">24 timer</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-orange-500">
                  <h3 className="text-lg font-semibold text-white mb-2">Marketing Cookies</h3>
                  <p className="text-zinc-400 text-sm mb-3">
                    Disse cookies bruges til at vise relevante annoncer og måle kampagneeffektivitet.
                  </p>
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-zinc-500">
                        <th className="pb-2">Navn</th>
                        <th className="pb-2">Formål</th>
                        <th className="pb-2">Varighed</th>
                      </tr>
                    </thead>
                    <tbody className="text-zinc-400">
                      <tr>
                        <td className="py-1 font-mono text-xs">_fbp</td>
                        <td className="py-1">Facebook Pixel</td>
                        <td className="py-1">3 måneder</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">Tredjepartscookies</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi bruger følgende tredjepartstjenester, som kan sætte deres egne cookies:
              </p>
              <ul className="list-disc list-inside text-zinc-400 mt-4 space-y-2">
                <li><strong className="text-white">Stripe:</strong> Sikker betalingsbehandling</li>
                <li><strong className="text-white">Google Analytics:</strong> Websiteanalyse (hvis aktiveret)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">Sådan Administrerer Du Cookies</h2>
              <p className="text-zinc-400 leading-relaxed">
                Du kan til enhver tid ændre eller tilbagetrække dit samtykke ved at:
              </p>
              <ul className="list-disc list-inside text-zinc-400 mt-4 space-y-2">
                <li>Klikke på "Cookie-indstillinger" i sidefoden</li>
                <li>Ændre indstillingerne i din browser</li>
                <li>Slette cookies manuelt via din browser</li>
              </ul>
              <p className="text-zinc-400 leading-relaxed mt-4">
                <strong className="text-white">Bemærk:</strong> Hvis du blokerer nødvendige cookies, kan dele af websitet muligvis ikke fungere korrekt.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">Browserindstillinger</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">
                Du kan administrere cookies via din browsers indstillinger:
              </p>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#DFFF00] hover:underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/da/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer" className="text-[#DFFF00] hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/da-dk/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#DFFF00] hover:underline">Safari</a></li>
                <li><a href="https://support.microsoft.com/da-dk/microsoft-edge/slet-cookies-i-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#DFFF00] hover:underline">Microsoft Edge</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">Kontakt</h2>
              <p className="text-zinc-400 leading-relaxed">
                Har du spørgsmål om vores brug af cookies, kan du kontakte os på <span className="text-[#DFFF00]">[EMAIL]</span>.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-wrap gap-4 text-sm text-zinc-500">
          <Link to="/terms" className="hover:text-[#DFFF00] transition-colors">Vilkår & Betingelser</Link>
          <span>•</span>
          <Link to="/privacy" className="hover:text-[#DFFF00] transition-colors">Privatlivspolitik</Link>
          <span>•</span>
          <Link to="/handelsbetingelser" className="hover:text-[#DFFF00] transition-colors">Handelsbetingelser</Link>
        </div>
      </div>
    </div>
  );
}
